import { useSmoothScroll } from "../../hooks/useSmoothScroll";

export const SmoothScroll = ({ children }) => {
  useSmoothScroll();
  return children;
};
